<template>
  <div class="user-info-wrapper" tabindex="0" ref="user">
    <div class="person">
      <v-avatar size="66" class="avatar-profile">
        <img
          class="avatar-image"
          :src="source.avatar_uri || require('@/assets/img/user-default.png')"
        />
      </v-avatar>
      <div class="">
        <div class="inline">
          <b class="nameType" :style="styles">{{ fullName() }}</b>
        </div>
        <div class="inline">
          <img class="email-icon" :src="require('@/assets/img/page1.png')" />
          <span class="text-style" :style="stylesMinor">{{ source.email || '' }}</span>
        </div>
        <div class="inline">
          <img class="phone-icon" :src="require('@/assets/img/fill1.png')" />
          <span class="text-style" :style="stylesMinor">{{ source.phone || '' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { capitalize } from '@/helper/index.js'
import { convertEmToPixels } from '@/helper/helper'

export default {
  name: 'profile-component',
  props: {
    index: {
      // index of current item
      type: Number
    },
    source: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    styles () {
      const result = convertEmToPixels(19)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    },
    stylesMinor () {
      const result = convertEmToPixels(16)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    }
  },
  methods: {
    fullName () {
      return `${capitalize(this.source.name) || ''} ${capitalize(
        this.source.surname
      ) || ''}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/profile/index.vue